import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleOAuthCallback, redirectToHostedUI } from '../utils/cognitoAuth';
import { useAuth } from '../context/AuthContext';

export default function CallbackPage() {
  const navigate       = useNavigate();
  const { refreshSession } = useAuth();
  const [error, setError]  = useState(null);

  useEffect(() => {
    let target = '/dashboard';
    handleOAuthCallback()
      .then(({ returnPath }) => { target = returnPath || '/dashboard'; return refreshSession(); })
      .then(() => navigate(target, { replace: true }))
      .catch(err => {
        const msg = err.message || '';
        if (msg === 'login_required' || msg === 'access_denied') {
          // Silent-auth attempt failed — redirect to full Cognito login
          redirectToHostedUI({ returnPath: '/dashboard' });
        } else {
          setError(msg || 'Sign-in failed');
        }
      });
  }, [navigate, refreshSession]);

  if (error) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: 16, color: 'var(--muted)' }}>
      <p>Sign-in error: {error}</p>
      <button className="btn btn-primary" onClick={() => redirectToHostedUI()}>Try again</button>
    </div>
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: 'var(--muted)' }}>
      Completing sign-in…
    </div>
  );
}
